import { getCurrentLocale, Locale } from '../../../../../context/I18n';

type TranslatableCategory = {
  Name: string;
  flair__English__c?: string | null;
  flair__German__c?: string | null;
  flair__French__c?: string | null;
  flair__Italian__c?: string | null;
  flair__Spanish__c?: string | null;
  flair__Norwegian__c?: string | null;
  flair__Russian__c?: string | null;
  flair__Portuguese__c?: string | null;
};

const localeFieldMap: Record<Locale, keyof TranslatableCategory> = {
  en: 'flair__English__c',
  'en-us': 'flair__English__c',
  de: 'flair__German__c',
  'de-ch': 'flair__German__c',
  fr: 'flair__French__c',
  it: 'flair__Italian__c',
  es: 'flair__Spanish__c',
  ru: 'flair__Russian__c',
  no: 'flair__Norwegian__c',
  pt: 'flair__Portuguese__c',
};

export const getTranslatedCategoryName = (
  category: TranslatableCategory,
  locale?: Locale,
): string => {
  const currentLocale = locale ?? getCurrentLocale();
  const field = localeFieldMap[currentLocale];
  return (field && category[field]) || category.Name;
};
